import ListOfCategoriesData from "../../ListOfCategories/ListOfCategoriesData";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  ShowSpecialsHandler,
  ShowAllsHandler,
} from "../../ListOfCategories/AdditionalListOfCategoriesData";
import SwiperListOfCategoriesLayout from "../../../Ui/swiperLayouts/SwiperListOfCategoriesLayout";

const DataCategoresItem = (props: any) => {
  return (
    <div className="pr-3 sm:px-4 py-1">
      <SwiperListOfCategoriesLayout>
        {props.dataCategory.map((item: any) => (
          <ListOfCategoriesData
            key={item.id}
            id={item.id}
            name={item.name}
            imageUrl={item.imageUrl}
          />
        ))}
        <ShowSpecialsHandler />
        <ShowAllsHandler />
      </SwiperListOfCategoriesLayout>
    </div>
  );
};

export default DataCategoresItem;
